(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hamper-package-carousels-no-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const carousels = document.querySelectorAll('.hamper-package-carousel-no-tabs__content [data-content]');
    carousels.forEach((el, index) => {
      el.style.zIndex = carousels.length - index;
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
